export default {
    methods: {
        mapType(type, lib) {
            const types = lib
            
            let name = null

            types.forEach(item => {
                if (item.value === type) {
                    name = item.name
                }
            })            
            
            return name
        }
    }
}